import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';
import { TextInput } from 'components/common/formElements';
import { mediumScreens, lowHeightScreens, smallScreens } from 'components/common/fontElements';

export const Wrapper = styled.div`
  height: 100%;
  overflow-y: scroll;
  position: relative;
`;

export const Content = styled.div`
  display: flex;
  padding: 100px 30px 200px 30px;
  margin: 0px;
  flex-direction: column;
  width: 70%;
  margin: 0px auto;
  @media (max-height: ${lowHeightScreens}) {
    padding: 70px 20px 25px 20px;
  }
  @media (max-width: ${mediumScreens}) {
    width: 100%;
  }
  @media (max-height: ${smallScreens}) {
    padding: ${(props) => props.reduceTopPadding && '30px 20px 200px 20px'};
  }
`;

export const EmailInput = styled(TextInput)`
  margin-top: 30px;
`;

export const Title = styled.p`
  padding: 0px 30px;
  font-family: 'Lato-Bold';
  margin-bottom: 0px !important;
  text-align: center;
  font-size: 14px;
  color: ${colors.black1};
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 12px;
  }
`;

export const SubText = styled.p`
  padding: 0px 30px;
  font-family: 'Lato';
  margin-bottom: 0px !important;
  text-align: center;
  font-size: 14px;
  color: ${colors.black1};
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 12px;
  }
`;

export const TextSection = styled.div`
  padding-bottom: 30px;
`;

export const InfoSection = styled.div`
  padding: 0px 30px;
`;

export const ButtonSection = styled.div`
  padding: 10px 30px 30px 30px;
  z-index: 50;
  bottom: 0px;
  position: absolute;
  width: 100%;
  min-height: 65px;
`;
